import { render, staticRenderFns } from "./mTitle.vue?vue&type=template&id=5db64466&scoped=true&"
import script from "./mTitle.vue?vue&type=script&lang=js&"
export * from "./mTitle.vue?vue&type=script&lang=js&"
import style0 from "./mTitle.vue?vue&type=style&index=0&id=5db64466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db64466",
  null
  
)

export default component.exports